import { v4 as uuidv4 } from "uuid";
export class EmployeeModel {
    constructor() {
        this.id = uuidv4();
        this.firstName = "";
        this.lastName = "";
        this.emailId = "";
        this.phoneNo = "";
        this.dateOfBirthAsString = "";
        this.dateOfJoinAsString = "";
        this.workPlace = "Office";
        this.skills = "";
        this.reportingTo = null;
        this.designationId = null;
        this.startTimeAsString = "";
        this.endTimeAsString = "";
    }
}
export default class Employee extends EmployeeModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
